import React from 'react'
import errorIcon from '../../../assets/images/Exclamation.svg'
import './temp_unavailable.scss'

const Temp_unavailable = () => {
    return (
        <div className="error_panel" >
        <div className="error_container">
            <img src={errorIcon}/>
            <div className="error_text">We are temporarily facing some technical<br/>
            glitch but we shall be back soon.<br/>
            Please try again after x hours</div>
        </div>
        </div>
    )
}

export default Temp_unavailable
